import Register from '../../components/identity/register/Register';
import Login from '../../components/identity/login/Login';
import DefaultLayout from '../../components/layouts/default-layout/DefaultLayout';
import { Route, useSearchParams } from 'react-router-dom';
import UserInformation from '../../components/identity/user-information/UserInformation';
import IdentityLayout from '../../components/layouts/identity-layout/IdentityLayout';
export default function IdentityRoute() {

    const [searchParams] = useSearchParams();
    return <>
        <Route element={<DefaultLayout backUri={"/Dashboard"} backIcon={"mdi-close"} title={"پروفایل"} />}>
            <Route path="/UserProfile" element={<UserInformation />} />
        </Route>



        <Route element={<IdentityLayout />}>
            <Route index element={<Login />} />
            <Route path="/Login" element={<Login />} />
            <Route path="/Register" element={<Register reffererId={searchParams.get('reffererId')} />} />
        </Route>
    </>
}